import {
  AdminArenaRow,
  AdminTransactionRow,
  ArenaSubscriptionStatus,
  DisputeRow,
  ModerationRow,
  WebhookEvent,
} from 'modules/admin/dashboard/types';

export const PLATFORM_KPIS = [
  { label: 'Arenas ativas', value: '3' },
  { label: 'MRR (assinaturas)', value: 'R$ 387' },
  { label: 'Volume transacionado (mês)', value: 'R$ 42,9 mil' },
  { label: 'Taxa da plataforma (2%)', value: 'R$ 858' },
  { label: 'Disputas abertas', value: '2' },
];

export const ADMIN_ARENAS: AdminArenaRow[] = [
  { id: 'praia-norte', name: 'Arena Praia Norte', city: 'Fortaleza-CE', units: 2, status: 'ativa', joinedLabel: 'jan/26', mrr: 129 },
  { id: 'aldeota-beach', name: 'Arena Aldeota Beach', city: 'Fortaleza-CE', units: 1, status: 'ativa', joinedLabel: 'mar/26', mrr: 129 },
  { id: 'coco-sports', name: 'Arena Cocó Sports', city: 'Fortaleza-CE', units: 1, status: 'trial', joinedLabel: 'ago/26', mrr: 0 },
  { id: 'beira-mar-club', name: 'Arena Beira Mar Club', city: 'Fortaleza-CE', units: 1, status: 'inadimplente', joinedLabel: 'jun/26', mrr: 129 },
];

export const ADMIN_TRANSACTIONS: AdminTransactionRow[] = [
  { id: '#10428', arenaName: 'Arena Praia Norte', amount: 83.2, platformFee: 1.66, status: 'pago', dateLabel: 'hoje 18:02' },
  { id: '#10427', arenaName: 'Arena Aldeota Beach', amount: 110, platformFee: 2.2, status: 'pendente', dateLabel: 'hoje 17:40' },
  { id: '#10391', arenaName: 'Arena Cocó Sports', amount: 41.6, platformFee: 0.83, status: 'estornado', dateLabel: 'ontem 20:15' },
  { id: '#10380', arenaName: 'Arena Praia Norte', amount: 250, platformFee: 5, status: 'pago', dateLabel: 'ontem 09:05' },
];

export const ADMIN_DISPUTES: DisputeRow[] = [
  { id: '#10391', arenaName: 'Arena Cocó Sports', playerName: 'Diego C.', reason: 'Reserva expirada sem uso da quadra', amount: 41.6, status: 'aberta' },
  { id: '#10355', arenaName: 'Arena Aldeota Beach', playerName: 'Marina L.', reason: 'Quadra em manutenção não avisada', amount: 80, status: 'em análise' },
];

export const ADMIN_MODERATION: ModerationRow[] = [
  { id: 'mural-1', arenaName: 'Arena Praia Norte', excerpt: 'Denúncia no mural: comentário ofensivo em racha', reason: 'Linguagem imprópria' },
];

// Analytics da plataforma (seções 3 e 4 do PRD: modelo de negócio e admin da plataforma).
export const MRR_TREND = [
  { label: 'Abr', value: 258 },
  { label: 'Mai', value: 258 },
  { label: 'Jun', value: 387 },
  { label: 'Jul', value: 387 },
  { label: 'Ago', value: 387 },
  { label: 'Set', value: 387 },
];

export const GMV_TREND = [
  { label: 'Abr', value: 28000 },
  { label: 'Mai', value: 31500 },
  { label: 'Jun', value: 35000 },
  { label: 'Jul', value: 38200 },
  { label: 'Ago', value: 40600 },
  { label: 'Set', value: 42900 },
];

const PLATFORM_FEE_MONTH = 858; // 2% de R$ 42.900 (GMV do mês)
const PROCESSOR_FEE_MONTH = 643.5; // ~1,5%, taxa do processador de pagamento

export const PLATFORM_REVENUE_SPLIT = [
  { id: 'arena', label: 'Repassado às arenas', value: 42900 - PLATFORM_FEE_MONTH - PROCESSOR_FEE_MONTH },
  { id: 'plataforma', label: 'Taxa da plataforma (2%)', value: PLATFORM_FEE_MONTH },
  { id: 'processador', label: 'Taxa do processador (~1,5%)', value: PROCESSOR_FEE_MONTH },
];

export const ARENAS_BY_PLAN = [
  { id: 'basico', label: 'Básico', value: 1 },
  { id: 'profissional', label: 'Profissional', value: 2 },
  { id: 'rede', label: 'Rede', value: 1 },
];

const STATUS_LABELS: Record<ArenaSubscriptionStatus, string> = {
  ativa: 'Ativa',
  trial: 'Trial',
  inadimplente: 'Inadimplente',
};

export const ARENAS_BY_STATUS = (Object.keys(STATUS_LABELS) as ArenaSubscriptionStatus[]).map((status) => ({
  id: status,
  label: STATUS_LABELS[status],
  value: ADMIN_ARENAS.filter((arena) => arena.status === status).length,
}));

// Webhooks & integrações (seções 4 e 15 do PRD: "consultar erros de integrações",
// falhas/tentativas de webhook registradas, processamento idempotente).
export const WEBHOOK_KPIS = [
  { label: 'Taxa de sucesso (24h)', value: '99,4%' },
  { label: 'Falhas (24h)', value: '3' },
  { label: 'Reprocessamentos pendentes', value: '1' },
];

export const WEBHOOK_SUCCESS_TREND = [
  { label: 'Seg', value: 98.2 },
  { label: 'Ter', value: 99.1 },
  { label: 'Qua', value: 97.6 },
  { label: 'Qui', value: 99.4 },
  { label: 'Sex', value: 98.9 },
  { label: 'Sáb', value: 99.7 },
  { label: 'Dom', value: 99.4 },
];

export const WEBHOOK_EVENTS: WebhookEvent[] = [
  { id: 'evt_9f3a', provider: 'Pix · PSP Alpha', eventType: 'payment.confirmed', arenaName: 'Arena Praia Norte', status: 'processado', dateLabel: 'hoje 18:03' },
  { id: 'evt_9f2c', provider: 'Cartão · PSP Beta', eventType: 'payment.confirmed', arenaName: 'Arena Aldeota Beach', status: 'processado', dateLabel: 'hoje 17:41' },
  { id: 'evt_9e88', provider: 'Pix · PSP Alpha', eventType: 'refund.completed', arenaName: 'Arena Cocó Sports', status: 'falhou', dateLabel: 'ontem 20:16' },
  { id: 'evt_9e71', provider: 'Cartão · PSP Beta', eventType: 'payment.confirmed', arenaName: 'Arena Praia Norte', status: 'reprocessando', dateLabel: 'ontem 09:06' },
  { id: 'evt_9e40', provider: 'Pix · PSP Alpha', eventType: 'payment.failed', arenaName: 'Arena Beira Mar Club', status: 'processado', dateLabel: 'ontem 08:55' },
];
